module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "query.99507992.png";